<template>
  <div class="c-buy-button__adimo-container">
    <div
      v-if="model.scriptType === 'productLightBox'"
      class="adimoWidget"
      data-type="lightbox"
      :data-default-language="model.defaultLanguage"
      :data-static-touchpoint-identifier="model.touchPointId"
      @click="trackButtonClick(model.touchPointId)"
    >
      <button :class="buttonCssClass">
        <span class="ltr:mr-2 rtl:ml-2">{{ model.text }}</span>
        <IconCart />
      </button>
    </div>
    <div
      v-if="model.scriptType === 'productPriceFirst'"
      class="adimo-site-product-first"
      data-type="site-product-first"
      :data-default-language="model.defaultLanguage"
      :data-static-touchpoint-identifier="model.touchPointId"
      @click="trackButtonClick(model.touchPointId)"
    >
      <button :class="buttonCssClass">
        <span class="ltr:mr-2 rtl:ml-2">{{ model.text }}</span>
        <IconCart />
      </button>
    </div>
    <div
      v-if="model.scriptType === 'recipeWidget'"
      class="adimo-container u-mb--s"
      data-type="recipe-widget"
      :data-touchpoint-id="model.touchPointId"
      :data-default-language="model.defaultLanguage"
      @click="trackButtonClick(model.touchPointId)"
    >
      <button :class="buttonCssClass">
        <span class="ltr:mr-2 rtl:ml-2">{{ model.text }}</span>
        <IconCart />
      </button>
    </div>
  </div>
</template>

<script>
import IconCart from '@/assets/icons/icon-cart.svg'
import adimoLoader from '@/lib/adimo-loader'

export default {
  components: {
    IconCart
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    buttonCssClass: {
      type: String,
      default: 'btn solid'
    }
  },
  mounted() {
    adimoLoader.loadAdimo(this.model.scriptType)
  },
  methods: {
    trackButtonClick(id) {
      const trackingObj = {
        event: 'AdimoCtaButton',
        placement: this.model.tracking.placement,
        action: 'BuyNow ctaButton',
        touchpointId: id
      }
      if (this.model.tracking.productName) {
        trackingObj.productName = this.model.tracking.productName
      }
      window.dataLayer.push(trackingObj)
    }
  }
}
</script>
